import { gsap } from "gsap";

export class MobileNavigation {
  constructor() {
    this.subMenus = document.querySelectorAll(
      ".nav-mobile ul li a[href]:has(+ ul)"
    );
    this.menuTriggerButton = document.querySelector(".nav-mobile-trigger");
    this.menuContainer = document.querySelector(".nav-mobile-container");
    this.menuTriggerButton.addEventListener(
      "click",
      this.ButtonClick.bind(this)
    );
    gsap.set(this.menuContainer, { xPercent: -100 });
    this.create();
  }

  create() {
    this.subMenus.forEach((a) => {
      const parent = a.parentElement;
      this.createDibber(parent);
      let menu = parent.querySelector("ul");
      this.animateMenu(menu);
      parent.addEventListener("click", this.DibberClick.bind(this, menu));
    });
  }

  createDibber(el) {
    el.innerHTML =
      el.innerHTML +
      `<div class="absolute top-2 right-0 cursor-pointer"><svg class="pointer-events-none w-6 h-6 rounded-full bg-white/10 text-custom_white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8 10 4 4 4-4"/></svg></div>`;
  }

  DibberClick(menu) {
    const clickedElement = event.target;
    if (clickedElement.tagName == "DIV") {
      const dir = menu.style.height === "0px" ? 1 : 0;
      gsap.to(menu, {
        height: dir ? "auto" : 0,
        opacity: dir ? 1 : 0,
        pointerEvents: dir ? "all" : "none",
        marginBottom: dir ? "16px" : "0px",
        ease: "power3",
        duration: 0.3,
      });
      gsap.to(clickedElement, {
        rotation: dir ? 180 : 0,
        ease: "back",
        duration: 0.3,
      });
    } else {
      location.href = a.href;
    }
    event.preventDefault();
  }

  animateMenu(el) {
    gsap.set(el, {
      height: 0,
      opacity: 0,
      pointerEvents: "none",
      marginBottom: "0px",
    });
  }

  ButtonClick(e) {
    let currentState = gsap.getProperty(this.menuContainer, "xPercent");
    gsap.to(this.menuContainer, {
      xPercent: currentState == -100 ? 0 : -100,
      overwrite: true,
      ease: "power3",
      duration: 0.4,
    });
  }
}
